import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 9C650D6F-20FE-4496-8973-B19509A47A18
 * name format-text-rotation-angle-up
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-text-rotation-angle-up.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatTextRotationAngleUpIcon = createSvgIcon(<><path d="M20.58 9.33V13.55L19.17 12.14L10.31 21L8.91 19.59L17.72 10.73L16.31 9.33M7.59 11L10.22 8.39L5.34 6.14M4.5 4.22L15.61 8.63L14.16 10.13L11.96 9.19L8.39 12.75L9.33 14.91L7.83 16.41L3.42 5.25Z" /></>, 'FormatTextRotationAngleUpIcon');
export default FormatTextRotationAngleUpIcon